import React from 'react';
import DotLoader from '../TailwindComponents/DotLoader';

const LoadingPage = () => {
    return (
      <div className="cs-h-dvh cs-grid cs-place-items-center">
        <DotLoader size="small" />
      </div>
    )
}

export default LoadingPage;